import { isNullOrUndefined } from '.';
/**
 * Checks if a given value is empty
 */
// tslint:disable-next-line: no-any
export function isEmpty(value) {
    if (isNullOrUndefined(value)) {
        return true;
    }
    switch (typeof value) {
        case 'object': {
            // tslint:disable-next-line: no-any
            return !Object.keys(value).length;
        }
        case 'string': {
            return !value.trim();
        }
        default: {
            return false;
        }
    }
}
